import { render, staticRenderFns } from "./EventRoutesField.vue?vue&type=template&id=9bd279fc"
import script from "./EventRoutesField.vue?vue&type=script&lang=js"
export * from "./EventRoutesField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports